export default __webpack_public_path__ + "static/media/about.bcfd3514.png";